import territoryCatalogsPayload from '@/data/recintos/territory-catalogs.json'
import type {
  AdministrativeLevel,
  CantonCatalogItem,
  VotingPlaceCatalogs,
} from '@/types/votingPlace'

type TerritoryCatalogsPayload = {
  catalogos: Pick<VotingPlaceCatalogs, 'provincias' | 'cantones'>
}

const catalogos = (territoryCatalogsPayload as TerritoryCatalogsPayload).catalogos

export function getTerritoryProvinceSlugOptions() {
  return (catalogos.provincias as AdministrativeLevel[])
    .map((province) => ({
      id: province.slug,
      label: province.nombre,
      codigo: province.codigo,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es'))
}

export function getTerritoryCantonSlugOptions(provinceSlug?: string) {
  const province = provinceSlug
    ? (catalogos.provincias as AdministrativeLevel[]).find(
        (item) => item.slug === provinceSlug,
      )
    : null

  return (catalogos.cantones as CantonCatalogItem[])
    .filter((canton) => !province || canton.provinciaCodigo === province.codigo)
    .map((canton) => {
      const cantonProvince =
        province ??
        (catalogos.provincias as AdministrativeLevel[]).find(
          (item) => item.codigo === canton.provinciaCodigo,
        )

      return {
        id: canton.slug,
        label: canton.nombre,
        provinceId: cantonProvince?.slug ?? '',
        codigo: canton.codigo,
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label, 'es'))
}
